import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { env } from '../configs/env'

export const startDatadogBrowserRum = () => {
  datadogRum.init({
    ...env.datadog.browserRum,
    env: env.datadog.env,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    startSessionReplayRecordingManually: false,
  })
}

export const startDatadogBrowserLogs = () => {
  datadogLogs.init({
    ...env.datadog.browserLogs,
    env: env.datadog.env,
    service: env.datadog.service,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}
